module.exports = __webpack_public_path__ + "img/rpraetorium64_ua.f277fd84.webp";